<script setup lang="ts">
type Props<T> = {
  answer: T
}
defineProps<Props<any>>()
</script>

<template>
  <div
    class="flex flex-1 flex-row justify-start rounded-lg border border-solid px-6 py-2"
    :class="[$style.ChoiceAnswer, answer.isCorrect ? $style.correct : '']"
  >
    <p class="flex-1">{{ answer.label }}</p>
    <i class="pi pi-check text-lg font-bold" v-if="answer.isCorrect"></i>
  </div>
</template>

<style module>
.ChoiceAnswer {
  border-color: var(--surface-400);

  p {
    cursor: default;
  }

  :global(.pi-check) {
    color: #22c55e;
  }

  &.correct {
    border: 1px solid #22c55e;

    p {
      font-weight: bold;
    }
  }
}
</style>
